<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6" style="margin-top: 10px;">
                Agency ID(s) <small>Space Separated</small>
                <input type="search" v-model="api_params.agency_id" class="form-control" @keyup.enter="search" placeholder="Agency Id">
            </div>

            <div class="col-md-6" style="margin-top: 30px;">
                <button class="btn btn-primary btn-block" @click.prevent="search"><i class="fa fa-search"></i> Search</button>
            </div>
        </div>
        <div class="row" style="margin-top:20px;">
            <pagination :current_page="pagination.current_page"
                        :total_pages="pagination.total_pages"
                        :from="pagination.from"
                        :to="pagination.to"
                        :total="pagination.total"
                        @go-to-page="handleGoToPage"
                        v-show="showPagination"
            ></pagination>
            <div :class="newMicrositeClasses" style="margin-bottom: 20px">
                <button class="btn btn-default"><i class="fas fa-sync-alt" @click.prevent="getMicrosites"></i></button>
                <a href="/microsites/templates" class="btn btn-primary">Templates</a>
                <a :href="newMicrositeUrl" class="btn btn-success">New Microsite</a>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="table-responsive">
                    <table class="table table-striped microsites-table">
                        <thead v-show="showTableHeaders">
                        <tr class="side-borders th_font">
                            <th v-for="header in headers" @click="sortHeader(header.name)" :style="{ width: getHeaderWidth(header) }">
                                {{ header.name | capitalize }}
                                <i class="fas fa-sort-down" v-if="header.sort === 'desc'"></i>
                                <i class="fas fa-sort-up" v-if="header.sort === 'asc'"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-show="showLoading">
                            <td colspan="6" class="text-center">
                                <i class="fa fa-spinner fa-spin fa-3x grey"></i><br/><br/>
                                Loading Microsites
                            </td>
                        </tr>
                        <tr v-show="showNoResultsFound">
                            <td colspan="6" class="text-center">
                                No results found
                            </td>
                        </tr>
                        <tr v-for="microsite in microsites" v-if="!showLoading">
                            <td><a target="_blank" :href="'https://www.french-property.com/estate-agents/' + microsite.agency.tag">{{
                                    microsite.agency.name
                                }} ({{ microsite.agency.id }})</a></td>
                            <td>{{ microsite.template.name }}</td>
                            <td>{{ microsite.path }}</td>
                            <td class="text-center">
                                <i class="fas fa-check text-success" v-if="microsite.active === true"></i>
                                <i class="fas fa-times text-danger" v-if="microsite.active === false"></i>
                            </td>
                            <td>{{ microsite.updated_at }}</td>
                            <td>
                                <a :href="microsite.edit_url" class="btn btn-sm btn-info">
                                    <i class="fas fa-cog"></i>
                                </a>
                                <button @click.prevent="deleteMicrosite(microsite)" class="btn btn-sm btn-danger">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="row">
            <pagination :current_page="pagination.current_page"
                        :total_pages="pagination.total_pages"
                        :from="pagination.from"
                        :to="pagination.to"
                        :total="pagination.total"
                        @go-to-page="handleGoToPage"
                        v-show="showPagination"
            ></pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: "microsites",
    props: ['newMicrositeUrl'],
    data() {
        return {
            api_params: {
                page: 1,
                order: 'updated_at',
                order_direction: 'desc',
                agency_id: '',
            },
            pagination: {
                current_page: 1,
                total_pages: 1,
                from: 1,
                to: 1,
                total: 1
            },
            is_loading: false,
            microsites: [],
            headers: [
                {name: 'agency', api_name: 'agency_id', width: '165px', sort: null, sortable: true,},
                {name: 'template', api_name: 'template_id', width: '240px', sort: null, sortable: true,},
                {name: 'path', api_name: 'path', sort: null, sortable: true,},
                {name: 'active', api_name: 'active', width: '95px', sort: null, sortable: true,},
                {name: 'last updated', api_name: 'updated_at', width: '160px', sort: null, sortable: true,},
                {name: '', sort: null, width: '86px', sortable: false,}
            ],
        };
    },
    mounted() {
        this.getMicrosites();
    },
    computed: {
        newMicrositeClasses() {
            return this.showPagination
                ? 'col-lg-8 col-md-8 col-sm-12 form-inline text-right'
                : 'col-lg-12 form-inline text-right';
        },
        showLoading() {
            return this.is_loading;
        },
        showTableHeaders() {
            return this.is_loading === false && (this.hasMicrosites || this.hasSearch)
        },
        hasSearch() {
            return this.api_params.search !== '';
        },
        showNoResultsFound() {
            return this.is_loading === false && this.hasMicrosites === false && this.hasSearch;
        },
        hasMicrosites() {
            return this.microsites.length > 0;
        },
        showPagination() {
            return this.hasMicrosites;
        },
    },
    methods: {
        getMicrosites() {
            this.is_loading = true;
            axios.get('/microsites/data', {params: this.api_params})
                .then(response => {
                    this.microsites = response.data.data;
                    this.pagination.current_page = response.data.current_page;
                    this.pagination.total_pages = response.data.last_page;
                    this.pagination.from = response.data.from;
                    this.pagination.to = response.data.to;
                    this.pagination.total = response.data.total;
                    this.is_loading = false;
                });
        },
        sortHeader(name) {
            let header = this.getHeaderByName(name);
            let currentSort = header.sort;

            if (header.sortable === false) {
                return;
            }

            this.resetHeaderSort();

            switch (currentSort) {
                case null:
                    header.sort = 'asc';
                    break;
                case 'asc':
                    header.sort = 'desc';
                    break;
                case 'desc':
                    header.sort = 'asc';
                    break;
            }

            this.api_params.order = header.api_name;
            this.api_params.order_direction = header.sort;

            this.getMicrosites();
        },
        getHeaderByName(name) {
            return this.headers.find(h => h.name === name);
        },
        getHeaderWidth(header) {
            return (header.hasOwnProperty('width')) ? header.width : false;
        },
        resetHeaderSort() {
            this.headers.forEach(h => h.sort = null);
        },
        search() {
            this.api_params.page = 1;
            this.getMicrosites();
        },
        handleGoToPage(page) {
            this.api_params.page = page;
            this.getMicrosites();
        },
        deleteMicrosite(microsite) {
            if (confirm("Are you sure you want to delete the microsite for " + microsite.agency.name + "?")) {
                axios.delete(microsite.delete_url)
                    .then(response => {
                        this.getMicrosites();
                    });
            }
        }
    },
}
</script>

<style scoped>
.microsites-table {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}
</style>